import { analiticaInstance } from 'shared/analitica'

import { type LucyAnalyticsAdapter } from '../types'

export function createLucyAmplitudeAnalytics(): LucyAnalyticsAdapter {
  const lucyAmplitudeEvents = analiticaInstance.eventFactory('LucyChat', {
    widget: {
      track: (label: string, metadata?: Record<string, unknown>) => ({
        label,
        metadata: metadata ?? {},
        filterPlugins: ['AMPLITUDE']
      })
    }
  })

  return {
    track: (event, props) => {
      lucyAmplitudeEvents.events.widget.track(event, props)
    }
  }
}
